/* ============
 * Provider-group Module State
 * ============
 */

export default {
  all: [
    {
      id: 'visma',
      name: 'Visma',
    },
    {
      id: 'duett',
      name: 'Duett',
    },
    {
      id: 'tripletex',
      name: 'Tripletex',
    },
  ],
  selectedProvider: '',
  clientProvider: false,
  downloadExportList: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/providerGroup/state.js